export const getFormattedPhone = (phone) => {
  return phone.slice(1).replace(/ /g, '');
};

export const removePlusFromPhone = (phone) => {
  return phone.slice(1).replace(/[+\s]/g, '');
}
